import React, { useState } from "react"
import { connect } from "react-redux"
import ReactTable from "react-table"
import { useApolloClient } from "react-apollo"
import { Form, Grid, Button, Checkbox, Container } from "@foris/foris-ui"
import styled from "styled-components"
import { GET_ROOMS_QUERY } from "./queries"

const TableWrapper = styled.div`
  & > .ReactTable .rt-table {
    max-height: 200px;
  }
`

interface ClassRoomVars {
  originId: number
  scenarioId: number
  filter?: {
    sectionId?: number
    respectRequiredBuildings?: boolean
    respectRequireCapacity?: boolean
    respectRequiredClassroomType?: boolean
    useNonUsableClassrooms?: boolean
    useOverload?: boolean
  }
}

const SearchClassRoom: React.FC<any> = ({
  currentModuleConfig,
  pathname,
  setVisibleClassRoomSearch,
  onSelectedNewClassRoon
}) => {
  const parts = pathname.split("/")
  const sectionId = parts.pop() || parts.pop()

  const client = useApolloClient()

  const [isLoading, setIsLoading] = useState(false)
  const [classrooms, setClassRooms] = useState([])

  // Form values
  const [respectRequiredBuildings, setRespectRequiredBuildings] = useState(false)
  const [respectRequireCapacity, setRespectRequireCapacity] = useState(false)
  const [respectRequiredClassroomType, setRespectRequiredClassroomType] = useState(false)
  const [useNonUsableClassrooms, setUseNonUsableClassrooms] = useState(false)
  const [useOverload, setUseOverload] = useState(false)

  const columns = [
    {
      Header: "ID",
      width: 50,
      accessor: "id",
      Cell: (props: any) => {
        return <div style={{ textAlign: "center" }}>{`${props.value}`}</div>
      }
    },
    {
      Header: "Edificio",
      width: 120,
      accessor: "building.name",
      Cell: (props: any) => {
        return <div style={{ textAlign: "center" }}>{`${props.value}`}</div>
      }
    },
    {
      Header: "Código",
      accessor: "code",
      Cell: (props: any) => {
        return <div style={{ textAlign: "center" }}>{`${props.value}`}</div>
      }
    },
    {
      Header: "Tipo",
      accessor: "classroomType.code",
      Cell: (props: any) => {
        return <div style={{ textAlign: "center" }}>{`${props.value}`}</div>
      }
    },
    {
      Header: "Capacidad",
      width: 100,
      accessor: "capacity",
      Cell: (props: any) => {
        return <div style={{ textAlign: "center" }}>{`${props.value}`}</div>
      }
    },
    {
      Header: "Sobrecarga",
      width: 100,
      accessor: "allowedOverflow",
      Cell: (props: any) => {
        return <div style={{ textAlign: "center" }}>{`${props.value}`}</div>
      }
    },
    {
      Header: "Total",
      width: 70,
      accessor: "total",
      Cell: (props: any) => {
        return (
          <div style={{ textAlign: "center" }}>{`${props.original.allowedOverflow +
            props.original.capacity}`}</div>
        )
      }
    },
    {
      Header: " ",
      accessor: "id",
      Cell: (row: any) => {
        return (
          <div style={{ textAlign: "center" }}>
            <Button
              size="mini"
              primary
              onClick={(e: any) => onSelectedNewClassRoon(row.original, e)}
            >
              usar
            </Button>
          </div>
        )
      }
    }
  ]

  return (
    <>
      <a className="back__btn" onClick={() => setVisibleClassRoomSearch()} title="Volver">
        « volver
      </a>
      <Grid style={{ marginTop: "5px", padding: "0 3em" }}>
        <Grid.Row>
          <Grid.Column width={11}>
            <Container style={{ padding: "0px" }}>
              <h5>Buscar sala para la sesión {sectionId}</h5>
              <hr />
              <Form>
                <Container>
                  <Grid.Row style={{ marginBottom: "1em" }}>
                    <Grid.Column>
                      <div style={{ marginRight: "1em", display: "inline" }}>Respetar:</div>
                      <div style={{ marginRight: "1em", display: "inline" }}>
                        <Checkbox
                          label="Tipos requeridos"
                          onClick={() => {
                            setRespectRequiredBuildings(!respectRequiredBuildings)
                          }}
                        />
                      </div>
                      <div style={{ marginRight: "1em", display: "inline" }}>
                        <Checkbox
                          label="Capacidad"
                          onClick={() => {
                            setRespectRequireCapacity(!respectRequireCapacity)
                          }}
                        />
                      </div>
                      <div style={{ marginRight: "1em", display: "inline" }}>
                        <Checkbox
                          label="Restricción Asignatura-edificio"
                          onClick={() => {
                            setRespectRequiredClassroomType(!respectRequiredClassroomType)
                          }}
                        />
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <div style={{ marginRight: "1em", display: "inline" }}>Considerar:</div>
                      <div style={{ marginRight: "1em", display: "inline" }}>
                        <Checkbox
                          label="Salas no usables"
                          onClick={() => {
                            setUseNonUsableClassrooms(!useNonUsableClassrooms)
                          }}
                        />
                      </div>
                      <div style={{ marginRight: "1em", display: "inline" }}>
                        <Checkbox
                          label="Sobrecarga"
                          onClick={() => {
                            setUseOverload(!useOverload)
                          }}
                        />
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Container>

                <h4>{classrooms.length} resultados </h4>

                <TableWrapper>
                  <ReactTable
                    loading={isLoading}
                    data={classrooms}
                    columns={columns}
                    minRows={3}
                    showPagination={false}
                    loadingText={"Cargando..."}
                    noDataText={"Sin resultados para mostrar"}
                  />{" "}
                </TableWrapper>

                <div style={{ padding: "1em 0 0 0" }}>
                  <Form.Button
                    primary
                    onClick={async () => {
                      setIsLoading(true)
                      const { data } = await client.query({
                        query: GET_ROOMS_QUERY,
                        variables: {
                          originId: currentModuleConfig.originId,
                          scenarioId: currentModuleConfig.scenarioId,
                          filter: {
                            sectionId: sectionId,
                            respectRequiredBuildings,
                            respectRequireCapacity,
                            respectRequiredClassroomType,
                            useNonUsableClassrooms,
                            useOverload
                          }
                        }
                      })
                      if (data && data.cube) setClassRooms(data.cube.editorClassroom.items)
                      setIsLoading(false)
                    }}
                  >
                    Buscar
                  </Form.Button>
                </div>
              </Form>
            </Container>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}

const mapStateToProps = (state: any) => ({
  pathname: state.router.location.pathname,
  currentModuleConfig: state.config.moduleConfig
})

export default connect(mapStateToProps)(SearchClassRoom)
